/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { connect } from 'react-redux';

import sessionSelectors from 'redux/reduxStore/session';
import navigationSelectors from 'redux/reduxStore/navigation';
import profileSelectors from 'redux/reduxStore/profile';
import userSelectors from 'redux/reduxStore/user';

import sessionActions from 'redux/actions/session';

import ProfileAvatar from 'components/features/ProfileAvatar';
import AppMenuStripes from 'components/images/AppMenuStripes';
import ProfileMenuPopup from './ProfileMenuPopup';

import './ProfileMenu.css';
import RevealDotsVertical from '../../images/RevealDotsVertical';

function mapStateToProps(state) {
  const profileId = userSelectors.getMainProfileId(state);
  return {
    profile: profileSelectors.get(state, profileId),
  };
};

function mapDispatchToProps(dispatch) {
  return {};
};

class ProfileMenu extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      isMenuOpen: false,
    };
  }

  render() {
    return (
      <div className="cmp-profilemenu">
        {
          this.state.isMenuOpen ? (
            <ProfileMenuPopup onClose={() => { this.setState({ isMenuOpen: false }); }} />
          ) : (
            <div className="avatarmenu" onClick={() => { this.setState({ isMenuOpen: true }); }}>
              <div className="stripes">
                <RevealDotsVertical className="fill-color-gsMiddle" />
              </div>
              <ProfileAvatar profile={this.props.profile} style={{ marginRight: 8 }} />
            </div>
          )
        }
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileMenu);
